export enum StoryPageType {
    Image = 'image',
    Video = 'video',
}

export enum StoryPageDisplay {
    Default = 'default',
    Flow = 'flow',
}
